import { createContext } from 'react'

import { WorkspaceUserContextType } from './types'

export const WorkspaceUserContext = createContext<WorkspaceUserContextType>(
  {} as WorkspaceUserContextType,
)
